// import CryptoJS from 'crypto-js';

// const secretKey = process?.env?.NEXT_PUBLIC_SECRET_KEY;

// export const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(JSON?.stringify(data), secretKey).toString();
// };

// export const decryptData = (encryptedData) => {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     return JSON?.parse(bytes.toString(CryptoJS.enc.Utf8));
// };


import CryptoJS from "crypto-js";

const secretKey = process.env.NEXT_PUBLIC_SECRET_KEY;

export const encryptData = (data) => {
  if (!secretKey) {
    throw new Error("NEXT_PUBLIC_SECRET_KEY is missing");
  }

  return CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretKey
  ).toString();
};

export const decryptData = (encryptedData) => {
  if (!secretKey) {
    throw new Error("NEXT_PUBLIC_SECRET_KEY is missing");
  }

  if (!encryptedData) {
    return null;
  }

  try {
    const bytes = CryptoJS.AES.decrypt(
      encryptedData,
      secretKey
    );

    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedData) {
      return null;
    }

    return JSON.parse(decryptedData);
  } catch (error) {
    console.error("Failed to decrypt data:", error);
    return null;
  }
};